import { Tasks } from '@components/Tasks/Tasks'
import { useAppDispatch } from '@hooks/redux'
import { RoutePaths } from '@interfaces/routePaths'
import {
  clearBreadcrumbs,
  setActionsButton,
  setActiveSection,
  setInviteButton,
} from '@redux/site/siteSlice'
import { useEffect } from 'react'

export const Base = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Tasks'))
    dispatch(clearBreadcrumbs())
    dispatch(setActionsButton(false))
    dispatch(setInviteButton(false))
  })

  return (
    <Tasks
      fullWidth
      state={{
        history: [
          {
            title: 'Tasks',
            href: RoutePaths.TASKS,
          },
        ],
      }}
    />
  )
}
